// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"101":"ProductPurchasePage","542":"CompanyProfilePage","718":"ContactPage","727":"HomeOriginPage","786":"BusinessContentPage"}[chunkId] + "." + {"101":"a3281ce8","542":"3ba21e9a","718":"70e182aa","727":"040fc53f","786":"23b7d4f1"}[chunkId] + ".js";
};